import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
const HeroStats = lazy(() => import('./components/HeroStats').then(m => ({
  default: m.HeroStats
})));
const PainPointsSection = lazy(() => import('./components/PainPointsSection').then(m => ({
  default: m.PainPointsSection
})));
const ProductShowcase = lazy(() => import('./components/ProductShowcase').then(m => ({
  default: m.ProductShowcase
})));
const VolumesDetail = lazy(() => import('./components/VolumesDetail').then(m => ({
  default: m.VolumesDetail
})));
const BonusesSection = lazy(() => import('./components/BonusesSection').then(m => ({
  default: m.BonusesSection
})));
const CountdownSection = lazy(() => import('./components/CountdownSection').then(m => ({
  default: m.CountdownSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FinalCTASection = lazy(() => import('./components/FinalCTASection').then(m => ({
  default: m.FinalCTASection
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
const PurchaseNotification = lazy(() => import('./components/PurchaseNotification').then(m => ({
  default: m.PurchaseNotification
})));
export function App() {
  useEffect(() => {
    // Defer Meta Pixel to idle time — no longer loading Google Fonts (using system fonts)
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(() => loadPixel(), {
        timeout: 10000
      });
    } else {
      setTimeout(loadPixel, 8000);
    }
  }, []);
  return <main className="font-body text-white bg-brand-dark overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <Suspense fallback={null} data-id="element-2">
        <div className="bg-brand-dark pt-4 md:pt-12 pb-8 md:pb-12" data-id="element-3">
          <HeroStats data-id="element-4" />
        </div>
        <PainPointsSection data-id="element-5" />
        <ProductShowcase data-id="element-6" />
        <VolumesDetail data-id="element-7" />
        <BonusesSection data-id="element-8" />
        <CountdownSection data-id="element-9" />
        <PricingSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <FAQSection data-id="element-13" />
        <FinalCTASection data-id="element-14" />
        <FooterSection data-id="element-15" />
        <PurchaseNotification data-id="element-16" />
      </Suspense>
    </main>;
}
function loadPixel() {
  if (typeof window !== 'undefined' && !(window as any).fbq) {
    const f = window as any;
    const n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [] as any[];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    (window as any).fbq('init', '1170774765082882');
    (window as any).fbq('track', 'PageView');
  }
}